module.exports = kolibriGlobal.coreVue.components.CoreBase;